// extracted by mini-css-extract-plugin
export default {"root":"MultilingualForm_root__jwD+r","label":"MultilingualForm_label__Xp33W"};